import * as DT from '../datatable/model';
import { criterionNames } from '../../interfaces';
import { ILog, IHistoricalData, IHistorical } from '../../models/common';

export enum Statuses {
  'All' = 'All',
  'Active' = 'Active',
  'Removed' = 'Removed',
}

export interface PKey {
  [criterionNames.serialNumber]: number | string;
  [criterionNames.manufactureId]: string;
}

export interface Identifiers extends PKey {
  serialPresentationLabel?: string;
  numericalIdentity?: string;
}

export interface Device extends Identifiers {
  [criterionNames.deviceName]: string;
  deviceType: number;
  showOrderNumber: boolean;
  [criterionNames.isActive]: boolean;
  [criterionNames.orderNumber]: string;
  [criterionNames.owner]: string;
  [criterionNames.userWithReadRights]: string;
  [criterionNames.availability]: number;
  [criterionNames.customerDeviceNo]: string;
}

export interface DeviceExtension {
  programNumber: string;
  configurationNumber: string;
  // longDeviceName: string;
  typeNumber: string;
  consumptionType: number;
  manuallyAssignedOwnership: boolean;
}

export type DeviceExtended = Device & DeviceExtension;

export interface FilterCritria {
  [criterionNames.serialNumber]: number | string;
  [criterionNames.snLabel]: string;
  [criterionNames.deviceStatus]: Statuses;
  [criterionNames.deviceName]: string;
  [criterionNames.orderNumber]: string;
  [criterionNames.owner]: string;
  [criterionNames.userWithReadRights]: string;
}

export interface Totals {
  totalConcentrators: number;
  totalGateways: number;
  totalMeters: number;
  totalRepeaters: number;
  totalValves: number;
}

export interface TotalsByType extends Totals {
  [key: string]: number;
}

export interface Data extends DT.IData<Device> {
  totalsByType?: TotalsByType;
}

export type Table = DT.ITable<Device>;

export interface TableSortCriterion {
  id: string;
  desc: boolean;
}

export interface ActionStatus {
  isDownloadFetching: boolean;
  isDeactiving: boolean;
  isActivating: boolean;
}

export interface State extends DT.IDatatableState<Device, FilterCritria> {
  data: Data;
  activeModal: string | undefined;
  actionStatus: ActionStatus;
}

export type ILogData = {
  eventMessage: number;
  userName: string;
  customerName: string;
};
export type Log = ILog & ILogData;

export type HistoricalData = IHistoricalData<Log>;
export type Historical = IHistorical<Log>;

export interface DeviceExtendedWithHistoricalData extends DeviceExtended {
  historicalLogs: HistoricalData;
}

export interface DeviceExtendedWithHistorical extends DeviceExtendedWithHistoricalData {
  historicalLogs: Historical;
}

interface SearchPageResExtra {
  totalsByType: TotalsByType;
}
export type SearchPageRes = DT.SearchPageResponse<Device> & SearchPageResExtra;

export type SearchPageFetchPL = DT.SearchPageBasePayload;
export type SearchPageSuccessPL = DT.SearchPageSuccessPayload<Device> &
  SearchPageResExtra;
export type SearchPageErrorPL = DT.SearchPageBasePayload;
